export default {"src":"/_next/static/media/csharp.7851ee36.svg","height":288,"width":256,"blurWidth":0,"blurHeight":0};